import React from 'react';

import { numberWithComma, decimalPlace2 } from 'src/utils/Utils';
import styles from './PayrollTableData.scss';
import Row from './Row';
import BoldRow from './BoldRow';
import { useTranslation } from 'react-i18next';

const getDeductionItems = payroll => payroll.employeePayAllowances.filter(item => item.allowanceType === 'deduction');

const PayrollDeductionDetail = ({ payroll}) => {
  const { t } = useTranslation();
  const deductionsWithoutTotalDeduction = payroll.deductions?.filter(deductions => deductions.label !== 'Total deduction');
  return (
    <div className={styles.paymentClm}>
      {payroll && (
        <table className="m-table-obvious">
          <thead>
            <tr>
              <th colSpan="2">{t('features.MyData.components.payroll.PayrollDeductionDetail.deduction')}</th>
            </tr>
          </thead>
          <tbody>
            {deductionsWithoutTotalDeduction.map(deductionItem => (
              <Row key={deductionItem.id} label={deductionItem.label} value={numberWithComma(decimalPlace2(deductionItem.value))} />
              ))}
            <BoldRow
              label={t('features.MyData.components.payroll.PayrollDeductionDetail.total_deduction')}
              value={numberWithComma(decimalPlace2(payroll.deductionAmount))}
            />
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PayrollDeductionDetail;
